import {
  ID_PLANT_CHANGED,
  ID_OBJECT_CHANGED,
  NODE_CHANGED,
  RESIZE_TREE,
  SET_DATA,
  } from './root-consts';
import { nodeChanged } from './../../common/broadcast-helper';

import settings from './../../../config.js';
import isMobileDevice from './../../common/mobile-device-helper';
import { getInitialIdPlant } from './../../common/url-schemes';

export function loadNode(idPlant) {
  return (dispatch, getState) => {
    const { rootReducer } = getState();
    const node = rootReducer.treeNodes.find(elem => (elem.idPlant === idPlant ? true : false));
    if (node) {
      dispatch(nodeLoaded(node));
      nodeChanged(idPlant, dispatch);
    }
  };
}

export function setData(data) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_DATA,
      payload: data
    });

    getInitialIdPlant().then(idPlants=> {
      if (idPlants && idPlants.length > 0) {
        const { rootReducer } = getState();
        const node = rootReducer.treeNodes.find(elem => (elem.idPlant == idPlants[0] ? true : false));
        dispatch(nodeLoaded(node));
        nodeChanged(idPlants[0], node.modelCode, dispatch);
      }
    });
  };
}

export function nodeLoaded(node) {
  return {
    type: NODE_CHANGED,
    payload: {
      idPlant: 0,
      idObject: node.idObject,
      pendingChanges: null,
      pendingChildChanges: null,
      pendingNodeUpdate: null
    }
  };
}

export function idPlantChanged(idPlant, modelCode) {
  return {
    type: ID_PLANT_CHANGED,
    payload:{
      idPlant: parseInt(idPlant),
      modelCode
    }
  };
}


export function idObjectChanged(idObject) {
  return {
    type: ID_OBJECT_CHANGED,
    payload:{
      idObject
    }
  };
}

export function resizeTree(treeDividerX) {
  return {
    type: RESIZE_TREE,
    payload: {
      treeDividerX
    }
  };
}


/** WEBPACK FOOTER **
 ** app/components/root/state/root-actions.js
 **/